import { createStyles } from 'antd-style'

export const useStyles = createStyles((_, props: { maxWidth?: number }) => ({
  searchBlock: {
    '.ant-input-search-button': {
      margin: 0,
      padding: '8px !important'
    },
    width: `${props?.maxWidth ?? 240}px !important`
  }
}))
